export class CompanyUserFilterModel {
    public role: string;
    public status: string;
    public filterKey: string;
    public companyId: number;

    constructor() {
        this.role = '';
        this.status = '';
    }
}
